import CryptoJS from 'crypto-js';

export const SHA1_BASE64 = (str: string) => CryptoJS.SHA1(str).toString(CryptoJS.enc.Base64);
